import React from 'react';
import { Box, Typography, Divider, Stack, Button } from '@mui/material';
import './PanelStyles.css';

const PanelShell = ({ title, children, onSave, onCancel, actions }) => {
  return (
    <Box className="panel-container" sx={{ p: 2, backgroundColor: 'var(--paper-bg)', borderRadius: 1 }}>
      {title && (
        <>
          <Typography className="panel-title" variant="h6" sx={{ color: 'var(--brand-accent)', mb: 1 }}>{title}</Typography>
          <Divider sx={{ mb: 2 }} />
        </>
      )}
      <Box className="panel-body" sx={{ display: 'grid', gap: 1.5, overflow: 'hidden', maxWidth: '100%' }}>{children}</Box>
      <Stack direction="row" spacing={1} sx={{ mt: 2, justifyContent: 'flex-end' }}>
        {actions}
        {onCancel && <Button onClick={onCancel}>İptal</Button>}
        {onSave && <Button className="action-button" variant="contained" sx={{ backgroundColor: 'var(--brand-primary)' }} onClick={onSave}>Kaydet</Button>}
      </Stack>
    </Box>
  );
};

export default PanelShell;
